import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { toasty } from "../../../../../../Helper";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  Box,
  TextField,
  Chip,
  IconButton,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Select as MuiSelect,
  MenuItem,
  FormControl,
  Input as MuiInput,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  TableHead,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import AddIcon from "@mui/icons-material/Add";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import { useDispatch, useSelector } from "react-redux";
import { Popconfirm } from "antd";
import {
  setOpenModal,
  updateInterviewStatus,
} from "../../../../../../redux/Actions/UserAction";
import styles from "../../openPosition.module.css";
import ModalManager from "../../../../../../components/modalManager";
import apiCall from "../../../../../API/apiService";
import apiEndpoints from "../../../../../API/apiEndpoints";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import RefreshIcon from "@mui/icons-material/Refresh";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Input as AntInput, message, Modal, Button, Select, Spin, Tabs, Badge, Table as AntTable, Statistic, Row, Col, Empty, Divider, Tag, Tooltip, Menu } from "antd";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import EditIcon from "@mui/icons-material/Edit";
import HistoryIcon from "@mui/icons-material/History";
import ScheduleInterviewSvg from "../../../../../assets/svgComponent/scheduleinterview.svg";
import EditSvg from "../../../../../assets/svgComponent/editApplicant.svg";
import ViewReportCardSvg from "../../../../../assets/svgComponent/viewReportcard.svg";
import cancelIcon from "../../../../../assets/svgComponent/cancel.svg";
import saveIcon from "../../../../../assets/svgComponent/save.svg";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import FlowAuditSvg from "../../../../../assets/svgComponent/Flow&Audit.svg";
import ScreenshotCarousel from "../components/ScreenshotCarousel";
import NotificationsIcon from "@mui/icons-material/Notifications";
import RemindersSvg from "../../../../../assets/svgComponent/reminders.svg";
import {
  BellOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  InfoCircleOutlined,
  ExclamationCircleOutlined,
  MessageOutlined,
  MailOutlined,
  SafetyOutlined,
} from "@ant-design/icons";
import UpdateIcon from "@mui/icons-material/Update";
import { Password } from "@mui/icons-material";
const { TabPane } = Tabs;
// Initialize the plugins if needed
dayjs.extend(utc);
dayjs.extend(timezone);

const inputStyle = {
  width: "368px",
  height: "34px",
  padding: "6px 10px",
  gap: "8px",
  borderRadius: "6px",
  border: "1px solid rgba(255, 255, 255, 1)",
  boxShadow:
    "0px 1px 2px 0px rgba(17, 24, 39, 0.08), 0px 0px 0px 1px rgba(17, 24, 39, 0.1)",
  backgroundColor: "#F3F4F6",
  fontSize: "14px",
  fontFamily: "Inter",
};

const labelStyle = {
  display: "block",
  fontSize: "14px",
  color: "#374151",
  marginBottom: "8px",
  fontWeight: "500",
};

const CandidateDetailsTable = ({ onClear }) => {
  const [candidate, setCandidate] = useState(null);
  const [newItem, setNewItem] = useState({
    applicant_id: "",
    round_no: null,
    date: "",
    time: "",
    interviewer: [],
  });
  const [newInterviewer, setNewInterviewer] = useState("");
  const [selectedInterviewId, setSelectedInterviewId] = useState(null);
  const { modalType } = useSelector((state) => state.user);
  const [roundDetailsData, setRoundDetailsData] = useState([]);
  const [jobOpening, setJobOpening] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isTranscriptLoading, setIsTranscriptLoading] = useState(false);
  const [jobInterviewId, setJobInterviewId] = useState(null);
  const [jobOpeningId, setJobOpeningId] = useState(null);
  const [copiedFeedbackId, setCopiedFeedbackId] = useState(null);
  const [events, setEvents] = useState([]);
  const [statusHistoryOpen, setStatusHistoryOpen] = useState(false);
  const [statusUpdateOpen, setStatusUpdateOpen] = useState(false);
  const [selectedInterview, setSelectedInterview] = useState(null);
  const [newStatus, setNewStatus] = useState("");
  const [statusRemarks, setStatusRemarks] = useState("");
  const [error, setError] = useState(null);
  const [questionsAsked, setQuestionsAsked] = useState(0);
  const [questionsAnswered, setQuestionsAnswered] = useState(0);
  const [auditLogOpen, setAuditLogOpen] = useState(false);
  const [expandedRounds, setExpandedRounds] = useState({});
  const [isSendingReportCard, setIsSendingReportCard] = useState(false);
  const [isRequestingFeedback, setIsRequestingFeedback] = useState(false);
  const [isCheatDetectionLoading, setIsCheatDetectionLoading] = useState(false);
  const [interviewIssueModalOpen, setInterviewIssueModalOpen] = useState(false);
  const [selectedIssue, setSelectedIssue] = useState("");
  const [issueComments, setIssueComments] = useState("");
  const [isSubmittingIssue, setIsSubmittingIssue] = useState(false);
  const inputRef = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isCarouselOpen, setIsCarouselOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [remindersData, setRemindersData] = useState(null);
  const [remindersOpen, setRemindersOpen] = useState(false);
  const [remindersLoading, setRemindersLoading] = useState(false);

  const [showScoreDescription, setShowScoreDescription] = useState(false);
  const [selectedScoreInfo, setSelectedScoreInfo] = useState(null);

  // Feedback status state variables
  const [feedbackStatusOpen, setFeedbackStatusOpen] = useState(false);
  const [feedbackStatus, setFeedbackStatus] = useState(null);
  const [feedbackStatusLoading, setFeedbackStatusLoading] = useState(false);

  // Correction status state variables
  const [correctionStatusOpen, setCorrectionStatusOpen] = useState(false);
  const [correctionStatus, setCorrectionStatus] = useState(null);
  const [correctionStatusLoading, setCorrectionStatusLoading] = useState(false);

  // Remark state variables
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [remarkData, setRemarkData] = useState({
    comment: "",
    type: "CALL",
  });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [isFeedbackModalVisible, setIsFeedbackModalVisible] = useState(false);
  const [feedbackModalData, setFeedbackModalData] = useState();

  const [activeTab, setActiveTab] = useState("1");

  const openCarousel = (index) => {
    setSelectedIndex(index);
    setIsCarouselOpen(true);
  };

  // Replace this line:
  // const { currentUser } = useSelector((state) => state.auth);

  // With this:
  const currentUser = useSelector((state) => state.user.currentUser);

  // If you're not sure about the exact structure, you can do:
  const user = useSelector((state) => state.user);
  console.log("User state:", user); // This will help you see the structure of your user state

  // Use useSelector to get the user info from the Redux store
  const userInfo = useSelector((state) => state.user.userInfo);

  const strongStyle = {
    minWidth: "120px",
    height: "18px",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "18px",
    letterSpacing: "-0.1px",
    textAlign: "left",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
    color: "var(--Gray-700, rgba(78, 78, 86, 1))",
    marginBottom: "4px",
  };

  const spanStyle = {
    minWidth: "150px",
    maxHeight: "66px", // Added max height
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "22px",
    letterSpacing: "-0.2px",
    textAlign: "left",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
    color: "var(--Gray-900, rgba(58, 58, 64, 1))",
    whiteSpace: "normal",
    wordBreak: "break-word",
    marginBottom: "4px",
    overflowY: "auto", // Added scroll
    scrollbarWidth: "thin", // For Firefox
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "3px",
    },
  };

  const tableCellStyle = {
    padding: "16px",
    gap: "5px",
    borderBottom: "0.5px solid rgba(0, 0, 0, 0.12)",
    verticalAlign: "top",
    maxHeight: "120px", // Added max height
  };

  const cellContentStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    marginBottom: "27px",
    maxHeight: "500px", // Added max height
    overflow: "hidden", // Contains the scrollable content
  };

  // Define the styles for the interview details box
  const interviewDetailsBoxStyle = {
    width: "97%",
    height: "20%",
    padding: "8px 16px",
    gap: "0px",
    borderRadius: "8px",
    justifyContent: "space-between",
    background: "var(--White, rgba(255, 255, 255, 1))",
    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.06)",
    border: "1px solid rgba(17, 24, 39, 0.1)",
    display: "flex", // Ensure the box is a flex container
    alignItems: "center",
  };

  // Add this validation function near the top of your component
  const isFormValid = () => {
    return (
      newItem.round_no 
     
    );
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const applicantId = searchParams.get("applicant_id");
    const interviewId = searchParams.get("job_opening_id");

    // Case 1: Direct URL access with parameters
    if (applicantId && interviewId) {
      localStorage.setItem("applicant_id", applicantId);
      localStorage.setItem("job_opening_id", interviewId);

      setJobInterviewId(interviewId);
      setJobOpeningId(interviewId);

      fetchData(applicantId).then((candidateData) => {
        if (candidateData && candidateData.job_opening_id) {
          fetchRoundData(applicantId);
        }
      });
    }
    // Case 2: Navigation from applicant list or interview list
    else if (applicantId) {
      // Store the applicant ID immediately
      localStorage.setItem("applicant_id", applicantId);

      fetchData(applicantId).then((candidateData) => {
        if (candidateData && candidateData.job_opening_id) {
          setJobInterviewId(candidateData.job_opening_id);
          setJobOpeningId(candidateData.job_opening_id);

          // Store the job_opening_id
          localStorage.setItem("job_opening_id", candidateData.job_opening_id);

          // Update URL with both IDs
          window.history.replaceState(
            null,
            "",
            `/candidate-details?applicant_id=${applicantId}&job_opening_id=${candidateData.job_opening_id}`
          );

          fetchRoundData(applicantId);
        }
      });
    }
    // Case 3: Page refresh with stored values
    else {
      const storedApplicantId = localStorage.getItem("applicant_id");
      const storedInterviewId = localStorage.getItem("job_opening_id");

      if (
        storedApplicantId &&
        storedInterviewId &&
        location.pathname === "/candidate-details"
      ) {
        // Restore the URL parameters
        window.history.replaceState(
          null,
          "",
          `/candidate-details?applicant_id=${storedApplicantId}&job_opening_id=${storedInterviewId}`
        );

        fetchData(storedApplicantId).then((candidateData) => {
          if (candidateData && candidateData.job_opening_id) {
            setJobInterviewId(candidateData.job_opening_id);
            setJobOpeningId(candidateData.job_opening_id);
            fetchRoundData(storedApplicantId);
          }
        });
      }
    }
  }, [location.search]);

  // Add cleanup on component unmount
  useEffect(() => {
    return () => {
      // Clear stored IDs when leaving the page
      localStorage.removeItem("applicant_id");
      localStorage.removeItem("job_opening_id");
    };
  }, []);

  const fetchRoundData = async (id) => {
    try {
      const response = await apiCall(
        "get",
        `${apiEndpoints.CANDIDATE_DETAILS}/${id}/interviews`
      );
      console.log("Fetched round data:", response);

      if (response && response.interviews && response.interviews.length > 0) {
        setRoundDetailsData(response.interviews);

        // Log the duration_minutes of the first event
        console.log(response.interviews[0].events[3].duration_minutes); // Added log statement

        // Get the first interview
        const firstInterview = response.interviews[0];
        setJobInterviewId(firstInterview.id);

        // Extract `questions_asked` and `questions_answered` from feedback
        const questionsAsked = firstInterview.feedback?.questions_asked || 0;
        const questionsAnswered =
          firstInterview.feedback?.questions_answered || 0;

        // Set state variables for the UI
        setQuestionsAsked(questionsAsked);
        setQuestionsAnswered(questionsAnswered);

        console.log("Questions Asked:", questionsAsked);
        console.log("Questions Answered:", questionsAnswered);
      } else {
        throw new Error("Invalid response structure or no interviews found");
      }
      setError(null);
    } catch (error) {
      console.error("Error fetching candidate data:", error);
      setError("Failed to fetch interview data. Please try again later.");
    }
  };

  const fetchJobOpeningData = async (interviewId) => {
    try {
      const data = await apiCall(
        "get",
        `${apiEndpoints.JOB_INTERVIEW}/${interviewId}`
      );
      console.log("Fetched job opening data:", data);
      setJobOpening(data);
      resetNewItem(data);
    } catch (error) {
      console.error("Error fetching job opening data:", error);
      if (error.response) {
        console.error("Error response:", error.response.data);
      }
    }
  };

  const fetchData = async (id) => {
    try {
      const data = await apiCall(
        "get",
        `${apiEndpoints.CANDIDATE_DETAILS}/${id}`
      );
      setCandidate(data);
      resetNewItem(data);
      return data; // Return the response
    } catch (error) {
      console.error("Error fetching candidate data:", error);
      return null;
    }
  };

  const fetchApplicantDetails = async (applicantId) => {
    try {
      const response = await apiCall(
        "get",
        `${apiEndpoints.CANDIDATE_DETAILS}/${applicantId}`
      );
      console.log("Fetched applicant details:", response);
      if (response) {
        const { job_opening_id } = response;

        // Update states and URL
        setJobOpeningId(job_opening_id);
        setCandidate(response);

        // Store IDs for refresh handling
        localStorage.setItem("applicant_id", applicantId);
        localStorage.setItem("job_opening_id", job_opening_id);

        // Update URL with both IDs
        window.history.replaceState(
          null,
          "",
          `/candidate-details?applicant_id=${applicantId}&job_opening_id=${job_opening_id}`
        );

        // Fetch additional data
        fetchRoundData(applicantId);
        fetchJobOpeningData(job_opening_id);
      }
    } catch (error) {
      console.error("Error fetching applicant details:", error);
      alert("Failed to fetch applicant details: " + error.message);
    }
  };

  const handleSaveApplicantDetails = async () => {
    console.log("Job Opening ID before save:", jobOpeningId);
    const payload = {
      id: candidate.id,
      current_ctc: candidate.current_ctc,
      expected_ctc: candidate.expected_ctc,
      notice_period: candidate.notice_period,
      skills: candidate.skills,
      candidate_name: candidate.candidate_name,
      candidate_email: candidate.candidate_email,
      candidate_phone: candidate.candidate_phone,
      current_company: candidate.current_company,
      experience: candidate.experience,
      current_location: candidate.current_location,
      notable_company: candidate.notable_company,
    };

    try {
      const response = await apiCall(
        "put",
        apiEndpoints.CANDIDATE_DETAILS,
        payload
      );
      message.success("Applicant details saved successfully");
      // Use fetchApplicantDetailsOnly instead of fetchData to avoid triggering job interview API calls
      fetchApplicantDetailsOnly(candidate.id);
    } catch (error) {
      console.error("Error saving applicant details:", error);
      message.error("Failed to save applicant details: " + error.message);
    }
  };

  const fetchOtherRoundData = async (id) => {
    try {
      const response = await apiCall(
        "get",
        `${apiEndpoints.CANDIDATE_DETAILS}/${id}/interviews`
      );
      console.log("Fetched round data:", response);

      if (response && response.interviews && response.interviews.length > 0) {
        setRoundDetailsData(response.interviews);

        // Use the actual id of the first interview
        const firstInterview = response.interviews[0];
        setJobInterviewId(firstInterview.id);
      } else {
        throw new Error("Invalid response structure or no interviews found");
      }
      setError(null);
    } catch (error) {
      console.error("Error fetching candidate data:", error);
      setError("Failed to fetch interview data. Please try again later.");
    }
  };

  const resetNewItem = (jobOpeningData) => {
    setNewItem({
      applicant_id: (jobOpeningData?.applicant_id ?? jobOpeningData?.id) || "",
      round_no: jobOpeningData?.round_no + 1 || null,
     
    });
  };

  const handleScheduleInterview = () => {
    dispatch(setOpenModal({ modalVisible: true }));
  };

  const handleEditApplicantDetails = () => {
    dispatch(setOpenModal({ modalVisible: true, modalType: "EDIT_APPLICANT" }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewItem((prev) => ({ ...prev, [name]: value }));
  };

  const parseDuration = (duration) => {
    if (typeof duration === "string" && duration.includes(":")) {
      // Keep the original MM:SS format
      return duration;
    }
    return "0:00"; // Default format for invalid durations
  };

  const handleAddInterviewer = () => {
    if (newInterviewer.trim() !== "") {
      setNewItem((prev) => ({
        ...prev,
        interviewer: [...prev.interviewer, newInterviewer.trim()],
      }));
      setNewInterviewer("");
    }
  };

  const handleRemoveInterviewer = (index) => {
    setNewItem((prev) => ({
      ...prev,
      interviewer: prev.interviewer.filter((_, i) => i !== index),
    }));
  };

  const handleSave = async () => {
    try {
      // Implement your API call to save the interview schedule
      await apiCall("post", apiEndpoints.JOB_INTERVIEW, newItem);
      alert("Interview scheduled successfully");
      // Optionally, you can refresh the job opening data here
      if (jobOpening?.id) {
        await fetchJobOpeningData(jobOpening.id);
      }
      dispatch(setOpenModal({ modalVisible: false }));
    } catch (error) {
      console.error("Error scheduling interview:", error);
    }
  };

  const handleClear = () => {
    resetNewItem(jobOpening);
  };

  const fetchFeedbackAndTranscript = async (interviewId) => {
    const result = await fetchFeedbackStatus(interviewId);
    if (result?.status === "PROCESSING") return null;
    message.loading({ content: "Generating feedback...", key: "feedback" });
    console.log("Generating feedback for interview:", interviewId);
    setIsLoading(true);
    try {
      if (!interviewId) {
        throw new Error("Interview ID is undefined");
      }

      const requestBody = {
        jobinterview_id: interviewId,
        generate_new: true,
      };
      console.log("Request body:", requestBody);

      const response = await apiCall(
        "put",
        `${apiEndpoints.JOB_INTERVIEW}/feedback`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("API call completed, response:", response);

      if (response.error) {
        throw new Error(`Server error: ${JSON.stringify(response.error)}`);
      }

      if (response.feedback.evaluation) {
        // Update the roundDetailsData state for the specific interview
        setRoundDetailsData((prevData) =>
          prevData.map((interview) =>
            interview.interview_id === interviewId
              ? { ...interview, feedback: response.feedback }
              : interview
          )
        );

        console.log("Feedback updated successfully");
        alert("Feedback updated successfully.");

        // Re-fetch the round data to ensure all data is up to date
        if (candidate?.id) {
          await fetchRoundData(candidate.id);
        }
      } else {
        throw new Error("No valid feedback received from the server");
      }
    } catch (error) {
      console.error("Error in fetchFeedbackAndTranscript:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // New function to fetch only transcript without generating feedback
  const fetchTranscript = async (interviewId) => {
    const result = await fetchCorrectionStatus(interviewId);
    if (result?.status == "PROCESSING") return null;
    message.loading({ content: "Fetching transcript...", key: "transcript" });
    console.log("Fetching transcript for interview:", interviewId);
    setIsTranscriptLoading(true);
    try {
      if (!interviewId) {
        throw new Error("Interview ID is undefined");
      }

      const response = await apiCall(
        "put",
        `/api/jobinterviews/correct-answer/${interviewId}`
      );

      console.log("Transcript API call completed, response:", response);

      if (response.error) {
        throw new Error(`Server error: ${JSON.stringify(response.error)}`);
      }

      // Re-fetch the round data to ensure all data is up to date
      if (candidate?.id) {
        await fetchRoundData(candidate.id);
      }
      toasty("Transcript updated successfully.");
    } catch (error) {
      console.error("Error in fetchTranscript:", error);
      alert("Failed to update transcript: " + error.message);
    } finally {
      setIsTranscriptLoading(false);
    }
  };

  // Function to fetch the feedback generation status
  const fetchFeedbackStatus = async (interviewId) => {
    setFeedbackStatusLoading(true);
    try {
      const response = await apiCall(
        "get",
        `api/jobinterviews/feedback-status/${interviewId}`
      );
      if (response.status === "PROCESSING") {
        // setFeedbackStatus(response.status);
        // setFeedbackStatusOpen(true);
        toasty("Feedback generation is currently in progress.", "warning");
        return { status: "PROCESSING" };
      }
    } catch (error) {
      console.error("Error fetching feedback status:", error);
      toasty("Error fetching feedback status", "error");
    } finally {
      setFeedbackStatusLoading(false);
    }
  };

  // Function to fetch the correction status
  const fetchCorrectionStatus = async (interviewId) => {
    setCorrectionStatusLoading(true);
    try {
      const response = await apiCall(
        "get",
        `api/jobinterviews/correction-status/${interviewId}`
      );
      // setCorrectionStatus(response.data);
      // setCorrectionStatusOpen(true);
      if (response.status === "PROCESSING") {
        // setFeedbackStatus(response.status);
        // setFeedbackStatusOpen(true);
        toasty("Transcript generation is currently in progress.", "warning");
        return { status: "PROCESSING" };
      }
    } catch (error) {
      console.error("Error fetching correction status:", error);
      toasty("Error fetching correction status", "error");
    } finally {
      setCorrectionStatusLoading(false);
    }
  };

  const handleCopyFeedback = (feedback, roundId) => {
    // Ensure feedback is not null or undefined
    if (feedback) {
      navigator.clipboard
        .writeText(feedback)
        .then(() => {
          setCopiedFeedbackId(roundId);
          setTimeout(() => setCopiedFeedbackId(null), 2000); // Reset after 2 seconds
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    } else {
      console.error("No feedback to copy");
    }
  };

  const handleStatusHistoryClick = (interview) => {
    setSelectedInterview(interview);
    setStatusHistoryOpen(true);
  };

  const handleStatusUpdateClick = (jobOpeningId, interviewId) => {
    console.log(
      "Clicked interview for status update, job opening ID:",
      jobOpeningId,
      "interview ID:",
      interviewId
    );
    
    // Find the specific interview by interview_id from the candidate's interviews array
    if (candidate && candidate.interviews && candidate.interviews.length > 0) {
      const interview = candidate.interviews.find(
        (int) => int.interview_id === interviewId
      );
      
      if (interview) {
        setSelectedInterview(interview);
        setNewStatus(interview?.status?.status || "");
        setStatusRemarks("");
        setStatusUpdateOpen(true);
      } else {
        console.error("Interview not found with ID:", interviewId);
      }
    } else {
      // Fallback to previous behavior if candidate.interviews is not available
      const interview = roundDetailsData.find(
        (int) => int.job_opening_id === jobOpeningId && int.interview_id === interviewId
      );
      setSelectedInterview(interview);
      setNewStatus(interview?.status?.status || "");
      setStatusRemarks("");
      setStatusUpdateOpen(true);
    }
  };

  const handleStatusUpdate = async () => {
    try {
      if (!selectedInterview?.interview_id) {
        throw new Error("No interview ID available");
      }
      
      console.log("Updating status for interview:", selectedInterview.interview_id);
      
      const response = await apiCall(
        apiEndpoints.JOB_INTERVIEW_STATUS.method,
        apiEndpoints.JOB_INTERVIEW_STATUS.url,
        {
          jobinterview_id: selectedInterview.interview_id,
          status: newStatus,
          remarks: statusRemarks,
        }
      );

      if (!response) {
        throw new Error("No response received from the server");
      }

      if (response.error) {
        throw new Error(response.error);
      }

      const istDate = dayjs
        .utc(response.timestamp)
        .add(5, "hour")
        .add(30, "minute"); // Convert to IST

      // Update the state based on which data structure we're using
      if (candidate && candidate.interviews && candidate.interviews.length > 0) {
        // Update in the candidate.interviews array
        setCandidate(prevCandidate => ({
          ...prevCandidate,
          interviews: prevCandidate.interviews.map(interview => 
            interview.interview_id === selectedInterview.interview_id
              ? {
                  ...interview,
                  status: { 
                    ...interview.status, 
                    status: newStatus,
                    timestamp: response.timestamp,
                    remarks: statusRemarks
                  }
                }
              : interview
          )
        }));
      }
      
      // Also update in roundDetailsData if it exists
      setRoundDetailsData((prevData) =>
        prevData.map((interview) =>
          interview.interview_id === selectedInterview.interview_id
            ? {
                ...interview,
                date: istDate.format("YYYY-MM-DD"),
                time: istDate.format("hh:mm A"),
                status: { 
                  ...interview.status, 
                  status: newStatus,
                  timestamp: response.timestamp,
                  remarks: statusRemarks
                },
              }
            : interview
        )
      );

      setStatusUpdateOpen(false);
      toasty("Status updated successfully.");
      
      // Re-fetch the round data to ensure all data is up to date
      if (candidate?.id) {
        await fetchRoundData(candidate.id);
      }

      // After updating the status, ensure the interview details are updated
      if (selectedInterview?.job_opening_id) {
        await fetchJobOpeningData(selectedInterview.job_opening_id);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Failed to update status: " + error.message);
    }
  };

  // Define the handleRoundToggle function
  const handleRoundToggle = (roundId) => {
    setExpandedRounds((prev) => ({
      ...prev,
      [roundId]: !prev[roundId], // Toggle only the clicked round
    }));
  };

  useEffect(() => {
    if (jobInterviewId) {
      console.log("Interview ID received:", jobInterviewId);
      // You can use this ID to fetch specific interview details if needed
    }
  }, [jobInterviewId]);

  const handleAlphabeticInput = (e) => {
    e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
  };

  const handleNumericInput = (e, fieldName) => {
    let value = e.target.value;

    // Remove any non-numeric characters except commas
    const cleanValue = value.replace(/[^\d,]/g, "");

    // Get the cursor position before state update
    const cursorPosition = e.target.selectionStart;

    // Prevent unnecessary re-render
    if (candidate[fieldName] !== cleanValue) {
      setCandidate((prev) => ({
        ...prev,
        [fieldName]: cleanValue,
      }));

      // Ensure focus stays on the input field after re-render
      requestAnimationFrame(() => {
        if (inputRef.current) {
          inputRef.current.focus();
          inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
        }
      });
    }
  };

  // Add this helper function near the top of your component
  const formatDuration = (duration) => {
    if (!duration) return "N/A";

    // If duration is already in MM:SS format, return as is
    if (typeof duration === "string" && duration.includes(":")) {
      return duration;
    }

    // If duration is a number, format it
    if (typeof duration === "number") {
      return duration.toFixed(2);
    }

    return "N/A";
  };

  const fetchReminders = async (applicantId) => {
    if (!applicantId) {
      console.error("No applicant ID provided for fetching reminders");
      toasty("No applicant ID available. Please try again.", "warning");
      return;
    }

    setRemindersLoading(true);
    try {
      const response = await apiCall(
        "get",
        `/api/reminders/status/${applicantId}`
      );
      console.log("Fetched reminders data:", response);
      console.log("Response type:", typeof response);

      // If response is a string, try to parse it
      let parsedResponse = response;
      if (typeof response === "string") {
        try {
          parsedResponse = JSON.parse(response);
          console.log("Parsed string response:", parsedResponse);
        } catch (parseError) {
          console.error("Failed to parse response string:", parseError);
        }
      }

      // Check if we have any data in the response
      const roundKeys = Object.keys(parsedResponse || {});
      console.log("Round keys:", roundKeys);

      if (roundKeys.length > 0) {
        // Process all rounds data
        const processedData = {};

        // Calculate total counts across all rounds
        let totalSentCount = 0;
        let totalPendingCount = 0;

        roundKeys.forEach((roundKey) => {
          const roundData = parsedResponse[roundKey];
          processedData[roundKey] = {
            job_interview_id: roundData.job_interview_id,
            round_number: roundKey, // Store the round number
            sent_count: roundData.sent_count || 0,
            pending_count: roundData.pending_count || 0,
            sent_reminders: roundData.sent_reminders || [],
            pending_reminders: roundData.pending_reminders || [],
          };

          totalSentCount += roundData.sent_count || 0;
          totalPendingCount += roundData.pending_count || 0;
        });

        // Store the processed data with round information
        setRemindersData({
          rounds: processedData,
          totalSentCount,
          totalPendingCount,
        });

        setRemindersOpen(true);
      } else {
        console.warn("No reminder data found in the response");
        toasty("No reminder data available for this candidate.", "warning");
      }
    } catch (error) {
      console.error("Error fetching reminders:", error);
      toasty(
        "Failed to fetch reminders: " +
          (error.message || "Unknown error", "error")
      );
    } finally {
      setRemindersLoading(false);
    }
  };

  const handleRemindersClick = () => {
    if (candidate && candidate.id) {
      fetchReminders(candidate.id);
    } else {
      alert("Candidate information not available");
    }
  };

  const formatReminderTime = (timeString) => {
    return dayjs(timeString).format("DD MMM YYYY, hh:mm A");
  };

  const handleAddRemark = () => {
    if (candidate && candidate.id) {
      setShowRemarkModal(true);
      setRemarkData({
        comment: "",
        type: "CALL",
      });
    } else {
      message.error("Candidate information not available");
    }
  };

  const handleRemarkInputChange = (e) => {
    const { name, value } = e.target;
    setRemarkData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRemarkTypeChange = (value) => {
    setRemarkData((prev) => ({
      ...prev,
      type: value,
    }));
  };

  const fetchApplicantDetailsOnly = async (applicantId) => {
    try {
      const response = await apiCall(
        "get",
        `${apiEndpoints.CANDIDATE_DETAILS}/${applicantId}`
      );
      console.log("Fetched applicant details:", response);
      if (response) {
        // Only update candidate data without additional API calls
        setCandidate(response);
      }
    } catch (error) {
      console.error("Error fetching applicant details:", error);
      message.error("Failed to fetch applicant details: " + error.message);
    }
  };

  const handleSubmitRemark = async () => {
    try {
      if (!candidate || !remarkData.comment) {
        message.error("Please add a comment");
        return;
      }

      const payload = {
        id: candidate.id,
        remark: {
          comment: remarkData.comment,
          type: remarkData.type,
        },
      };

      const response = await apiCall("put", `/api/applicants`, payload);

      if (response) {
        setShowRemarkModal(false);
        toasty("Remark added successfully");
        // Only fetch applicant data without triggering job interview API calls
        fetchApplicantDetailsOnly(candidate.id);
      }
    } catch (error) {
      console.error("Error adding remark:", error);
      message.error("Failed to add remark");
    }
  };

  const renderEditApplicantComponent = () => {
    return (
      <ModalManager customWidth={window.innerWidth / 300}>
        <div
          style={{
            width: "410px",
            height: "88vh",
            fontFamily: "inter",
            padding: "0",
            borderRadius: "12px",
            backgroundColor: "#FFFFFF",
            position: "fixed",
            right: "12px",
            top: "12px",
            overflowY: "auto",
            overflowX: "hidden",
            boxShadow: `
						0px 20px 44px 0px rgba(0, 0, 0, 0.1),
						0px 80px 80px 0px rgba(0, 0, 0, 0.09),
						0px 180px 108px 0px rgba(0, 0, 0, 0.05),
						0px 319px 128px 0px rgba(0, 0, 0, 0.01),
						0px 499px 140px 0px rgba(0, 0, 0, 0)
					`,
            paddingRight: "12px",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <div
            style={{
              width: "100%",
              height: "48px",
              padding: "8px 16px",
              borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              background: "rgba(247, 247, 248, 1)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.00156 4.19961H2.10156V3.14961C2.10156 2.57001 2.57196 2.09961 3.15156 2.09961H5.22706C5.46086 2.09961 5.67996 2.21651 5.80946 2.41111L7.00156 4.19961Z"
                  fill="#2563EB"
                  stroke="#2563EB"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.10156 4.19971H10.8516C11.4312 4.19971 11.9016 4.67011 11.9016 5.24971V9.79971C11.9016 10.9589 10.9608 11.8997 9.80156 11.8997H4.20156C3.04236 11.8997 2.10156 10.9589 2.10156 9.79971V4.19971Z"
                  stroke="#2563EB"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span
                style={{
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Edit Applicant Details
              </span>
            </div>
          </div>

          {/* Form Content */}
          <div
            style={{
              padding: "24px 12px 24px 24px",
              width: "100%",

              overflowY: "auto",
            }}
          >
            {/* Input Fields */}
            <div style={{ marginBottom: "24px" }}>
              <label style={labelStyle}>Name</label>
              <AntInput
                label="Name"
                name="candidate_name"
                value={candidate.candidate_name || ""}
                onChange={(e) => {
                  handleAlphabeticInput(e);
                  setCandidate((prev) => ({
                    ...prev,
                    candidate_name: e.target.value,
                  }));
                }}
                style={inputStyle}
                placeholder="Enter name"
              />
            </div>

            <div style={{ marginBottom: "24px" }}>
              <label style={labelStyle}>Email</label>
              <AntInput
                label="Email"
                name="candidate_email"
                value={candidate.candidate_email || ""}
                onChange={(e) => {
                  setCandidate((prev) => ({
                    ...prev,
                    candidate_email: e.target.value,
                  }));
                }}
                placeholder="Enter email"
                style={inputStyle}
              />
            </div>

            <div style={{ marginBottom: "24px" }}>
              <label style={labelStyle}>Phone Number</label>
              <AntInput
                label="Phone Number"
                name="candidate_phone"
                value={candidate.candidate_phone || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  // Only allow digits and limit to 10 characters
                  if (/^\d{0,10}$/.test(value)) {
                    setCandidate((prev) => ({
                      ...prev,
                      candidate_phone: value,
                    }));
                  }
                }}
                placeholder="Enter phone number"
                style={inputStyle}
                maxLength={10}
                pattern="[0-9]{10}"
                onKeyPress={(e) => {
                  // Prevent non-numeric characters
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                type="tel"
              />
            </div>

            <div style={{ marginBottom: "24px" }}>
              <label style={labelStyle}>Current Company</label>
              <AntInput
                label="Current Company"
                name="current_company"
                value={candidate.current_company || ""}
                onChange={(e) => {
                  handleAlphabeticInput(e);
                  setCandidate((prev) => ({
                    ...prev,
                    current_company: e.target.value,
                  }));
                }}
                placeholder="Enter current company"
                style={inputStyle}
              />
            </div>

            <div style={{ marginBottom: "24px" }}>
              <label style={labelStyle}>Current CTC</label>
              <AntInput
                label="Current CTC"
                name="current_ctc"
                value={candidate.current_ctc || ""}
                onChange={(e) => handleNumericInput(e, "current_ctc")}
                placeholder="Enter current CTC"
                type="text"
                autoComplete="off"
                ref={inputRef}
                style={inputStyle}
              />
            </div>

            <div style={{ marginBottom: "24px" }}>
              <label style={labelStyle}>Expected CTC</label>
              <AntInput
                label="Expected CTC"
                name="expected_ctc"
                value={candidate.expected_ctc || ""}
                onChange={(e) => {
                  // handleNumericInput(e);
                  setCandidate((prev) => ({
                    ...prev,
                    expected_ctc: e.target.value,
                  }));
                }}
                // onChange={(e) => handleNumericInput(e, 'expected_ctc')}
                placeholder="Enter expected CTC"
                type="text"
                autoComplete="off"
                style={inputStyle}
              />
            </div>

            <div style={{ marginBottom: "24px" }}>
              <label style={labelStyle}>Notice Period</label>
              <AntInput
                label="Notice Period"
                name="notice_period"
                value={candidate.notice_period || ""}
                onChange={(e) => {
                  setCandidate((prev) => ({
                    ...prev,
                    notice_period: e.target.value,
                  }));
                }}
                placeholder="Enter notice period"
                style={inputStyle}
              />
            </div>

            <div style={{ marginBottom: "24px" }}>
              <label style={labelStyle}>Experience</label>
              <AntInput
                label="Experience"
                name="experience"
                value={candidate.experience || ""}
                onChange={(e) => {
                  setCandidate((prev) => ({
                    ...prev,
                    experience: e.target.value,
                  }));
                }}
                placeholder="Enter experience"
                style={inputStyle}
              />
            </div>

            <div style={{ marginBottom: "24px" }}>
              <label style={labelStyle}>Location</label>
              <AntInput
                label="Location"
                name="current_location"
                value={candidate.current_location || ""}
                onChange={(e) => {
                  setCandidate((prev) => ({
                    ...prev,
                    current_location: e.target.value,
                  }));
                }}
                placeholder="Enter location"
                style={inputStyle}
              />
            </div>

            <div style={{ marginBottom: "24px" }}>
              <label style={labelStyle}>Notable Companies</label>
              <AntInput
                label="Notable Companies"
                name="notable_company"
                value={candidate.notable_company?.join(", ") || ""}
                onChange={(e) => {
                  setCandidate((prev) => ({
                    ...prev,
                    notable_company: e.target.value.split(", "),
                  }));
                }}
                placeholder="Enter notable companies"
                style={inputStyle}
                type="text"
              />
            </div>

            <div style={{ marginBottom: "24px" }}>
              <label style={labelStyle}>Skills</label>
              <AntInput
                label="Skills"
                name="skills"
                value={candidate.skills?.join(", ") || ""}
                onChange={(e) => {
                  setCandidate((prev) => ({
                    ...prev,
                    skills: e.target.value.split(", "),
                  }));
                }}
                placeholder="Enter skills"
                style={inputStyle}
                type="text"
              />
            </div>
          </div>

          {/* Footer with Save/Cancel buttons */}
          <div
            style={{
              width: "400px",
              height: "45px",
              display: "flex",
              gap: "10px",
              padding: "16px",
              background: "rgba(247, 247, 248, 1)",
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              position: "sticky",
              bottom: 0,
              left: 0,
              right: 0,
              borderTop: "1px solid rgba(0, 0, 0, 0.1)",
            }}
          >
            <img
              src={cancelIcon}
              onClick={handleClear}
              alt="cancel"
              style={{
                width: "180px",
                height: "50px",
                objectFit: "contain",
                cursor: "pointer",
                transition: "transform 0.2s",
              }}
              onMouseDown={(e) =>
                (e.currentTarget.style.transform = "scale(0.95)")
              }
              onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            />

            <img
              src={saveIcon}
              onClick={handleSaveApplicantDetails}
              alt="save"
              style={{
                width: "180px",
                height: "48px",
                objectFit: "contain",
                cursor: "pointer",
                transition: "transform 0.2s",
              }}
              onMouseDown={(e) =>
                (e.currentTarget.style.transform = "scale(0.95)")
              }
              onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            />
          </div>
        </div>
      </ModalManager>
    );
  };

  const renderScheduleComponent = () => {
    return (
      <ModalManager customWidth={window.innerWidth / 300}>
        <div
          style={{
            width: "410px",
            height: "35vh",
            fontFamily: "inter",
            padding: "0",
            borderRadius: "12px",
            backgroundColor: "#FFFFFF",
            position: "fixed",
            right: "12px",
            top: "12px",
            overflowY: "auto",
            overflowX: "hidden",
            boxShadow: `
						0px 20px 44px 0px rgba(0, 0, 0, 0.1),
						0px 80px 80px 0px rgba(0, 0, 0, 0.09),
						0px 180px 108px 0px rgba(0, 0, 0, 0.05),
						0px 319px 128px 0px rgba(0, 0, 0, 0.01),
						0px 499px 140px 0px rgba(0, 0, 0, 0)
					`,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <div
            style={{
              width: "100%",
              height: "48 px",
              padding: "8px 16px",
              borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              background: "rgba(247, 247, 248, 1)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                marginTop: "15px",
              }}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.00156 4.19961H2.10156V3.14961C2.10156 2.57001 2.57196 2.09961 3.15156 2.09961H5.22706C5.46086 2.09961 5.67996 2.21651 5.80946 2.41111L7.00156 4.19961Z"
                  fill="#2563EB"
                  stroke="#2563EB"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.10156 4.19971H10.8516C11.4312 4.19971 11.9016 4.67011 11.9016 5.24971V9.79971C11.9016 10.9589 10.9608 11.8997 9.80156 11.8997H4.20156C3.04236 11.8997 2.10156 10.9589 2.10156 9.79971V4.19971Z"
                  stroke="#2563EB"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span
                style={{
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Schedule Interview
              </span>
            </div>
          </div>

          {/* Form Content */}
          <div
            style={{
              padding: "24px 12px 0 24px",
              flexGrow: 1,
              overflowY: "auto",
            }}
          >
            <div style={{ marginBottom: "24px" }}>
              <label
                style={{
                  display: "block",
                  fontSize: "14px",
                  color: "#374151",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Round Number <span style={{ color: "red" }}>*</span>
              </label>
              <AntInput
                name="round_no"
                value={newItem.round_no || ""}
                onChange={(e) => {
                  const { name, value } = e.target;
                  setNewItem((prev) => ({ ...prev, [name]: value }));
                }}
                type="number"
                placeholder="Enter round number"
                required
              />
            </div>

            

           
          
          </div>

          {/* Footer with Save/Cancel buttons */}
          <div
            style={{
              width: "100%",
              display: "flex",
              gap: "10px",
              padding: "16px",
              background: "rgba(247, 247, 248, 1)",
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              borderTop: "1px solid rgba(0, 0, 0, 0.1)",
            }}
          >
            <img
              src={cancelIcon}
              onClick={handleClear}
              alt="cancel"
              style={{
                width: "180px",
                height: "50px",
                objectFit: "contain",
                cursor: "pointer",
                transition: "transform 0.2s",
              }}
              onMouseDown={(e) =>
                (e.currentTarget.style.transform = "scale(0.95)")
              }
              onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            />

            <img
              src={saveIcon}
              alt="save"
              style={{
                width: "180px",
                height: "48px",
                objectFit: "contain",
                cursor: isFormValid() ? "pointer" : "not-allowed",
                transition: "transform 0.2s",
                opacity: isFormValid() ? 1 : 0.5,
              }}
              onMouseDown={(e) =>
                isFormValid() &&
                (e.currentTarget.style.transform = "scale(0.95)")
              }
              onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
              onClick={isFormValid() ? handleSave : undefined}
            />
          </div>
        </div>
      </ModalManager>
    );
  };

  const formatTimestamp = (timestamp) => {
    const istTime = dayjs.utc(timestamp).add(5, "hour").add(30, "minute"); // Convert to IST
    return istTime.format("DD MMM YYYY, hh:mm A");
  };

  const renderCombinedFlowAndAuditComponent = () => {
    const selectedInterview = roundDetailsData.find(
      (interview) => interview.interview_id === selectedInterviewId
    );

    return (
      <ModalManager customWidth="100%">
        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: "76vh",
            backgroundColor: "#fff",
            backgroundSize: "20px 20px",
            backgroundPosition: "0 0, 10px 10px",
            overflowX: "hidden",
            position: "relative",
          }}
        >
          {/* Left Section - Flow Log (33%) */}
          <Box
            sx={{
              width: "33%",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              overflowX: "hidden",
              position: "relative",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mb: 3,
                padding: "12px 16px",
                borderRadius: "8px",
                backgroundColor: "#ffffff",
                boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                width: "100%",
                height: "30px",
              }}
            >
              <Typography>
                <span style={{ color: "#000000" }}>Flow Log</span>
                <span style={{ color: "#2563EB" }}>
                  {" "}
                  - Round-{selectedInterview?.round_no}
                </span>
              </Typography>
            </Box>

            {/* Flow Content */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
                alignItems: "center",
                flex: 1,
                height: "66vh",
                overflowY: "auto",
                width: "100%",
              }}
            >
              {selectedInterview?.events?.map((event, index) => (
                <Box
                  key={index}
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <Card
                    sx={{
                      width: "90%", // Changed from fixed width
                      maxWidth: "368px", // Added max-width
                      height: "auto", // Changed from fixed height
                      minHeight: "135px", // Added min-height
                      borderRadius: "10px",
                      gap: "16px",
                      padding: "8px 12px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      border: "1px solid #e0e0e0",
                      backgroundColor: "#fff",
                      overflow: "hidden", // Ensure overflow is hidden
                    }}
                  >
                    <CardContent
                      style={{
                        marginLeft: "-10px",
                        marginTop: "-10px",
                        maxHeight: "100px",
                        overflowY: "auto",
                      }}
                    >
                      {" "}
                      {/* Added maxHeight and overflowY */}
                      <Typography
                        sx={{
                          color: "#666",
                          mb: 1,
                          fontSize: "14px",
                          fontFamily: "Inter",
                          fontWeight: "500",
                        }}
                      >
                        Round-1:
                      </Typography>
                      <Typography
                        variant="h6"
                        sx={{
                          mb: 1,
                          fontSize: "16px",
                          fontFamily: "Inter",
                          fontWeight: "500",
                        }}
                      >
                        {event.message}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#666",
                          fontSize: "14px",
                          fontFamily: "Inter",
                          fontWeight: "500",
                        }}
                      >
                        {event.timestamp
                          ? formatTimestamp(event.timestamp)
                          : "Timestamp not available"}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#666",
                          fontSize: "14px",
                          fontFamily: "Inter",
                          fontWeight: "500",
                        }}
                      >
                        Minutes elapsed:{" "}
                        {parseDuration(event.duration_minutes) || "N/A"}
                      </Typography>
                    </CardContent>
                  </Card>

                  {index < selectedInterview?.events.length - 1 && (
                    <Box
                      sx={{
                        mt: 2,
                        mb: 2,
                        "& svg": {
                          color: "#2563EB",
                          fontSize: "2rem",
                        },
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </Box>
                  )}
                </Box>
              ))}
            </Box>
          </Box>

          {/* Middle Section - Audit Log (33%) */}
          <Box
            sx={{
              width: "33%",
              padding: "20px",
              overflowY: "auto",
              position: "relative",
              height: "100%",
              backgroundColor: "#ffffff",
              borderLeft: "1px solid #e0e0e0",
              cursor: "pointer",
              "&::-webkit-scrollbar": {
                width: "8px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#888",
                borderRadius: "4px",
                "&:hover": {
                  background: "#555",
                },
              },
            }}
          >
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: "12px 16px",
                borderRadius: "8px",
                backgroundColor: "#ffffff",
                boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                marginBottom: "20px",
                width: "100%",
                height: "30px",
                alignItems: "center", // Add this to center vertically
              }}
            >
              <Typography sx={{ marginTop: "-4px" }}>
                {" "}
                {/* Add negative margin to move text up */}
                <span style={{ color: "#000000" }}>Audit Log</span>
                <span style={{ color: "#2563EB" }}>
                  {" "}
                  - Round-{selectedInterview?.round_no}
                </span>
              </Typography>
            </Box>

            {/* Audit Content */}
            <Box
              sx={{
                mt: 1,
                width: "100%",
                overflow: "scroll",
                height: "66vh",
              }}
            >
              {selectedInterview?.audit_log?.map((log, logIndex) => (
                <Card
                  key={logIndex}
                  sx={{
                    mb: 2,
                    borderRadius: "8px",
                    boxShadow: "none",
                    border: "1px solid",
                    borderColor: log.type === "error" ? "#ffcdd2" : "#c8e6c9",
                    backgroundColor:
                      log.type === "error" ? "#ffebee" : "#f1f8e9",
                  }}
                >
                  <CardContent>
                    <Typography
                      sx={{
                        color: "#666",
                        mb: 1,
                        fontSize: "14px",
                        fontFamily: "Inter",
                        fontWeight: "500",
                      }}
                    >
                      Round-{selectedInterview.round_no}:
                    </Typography>
                    <Typography
                      sx={{
                        color: log.type === "error" ? "#d32f2f" : "#2e7d32",
                        mb: 1,
                      }}
                    >
                      {log.message}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#666",
                        fontSize: "14px",
                        fontFamily: "Inter",
                        fontWeight: "500",
                      }}
                    >
                      {formatTimestamp(log.timestamp)}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#666",
                        fontSize: "14px",
                        fontFamily: "Inter",
                        fontWeight: "500",
                      }}
                    >
                      Minutes elapsed: {formatDuration(log.duration_minutes)}
                    </Typography>
                  </CardContent>
                </Card>
              ))}
            </Box>
          </Box>

          {/* New Right Section - Screenshots (33%) */}
          <Box
            sx={{
              width: "30%",
              padding: "20px",
              overflowY: "scroll",
              position: "relative",
              height: "100%",
              backgroundColor: "#ffffff",
              borderLeft: "1px solid #e0e0e0",
              cursor: "pointer",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: "12px 16px",
                borderRadius: "8px",
                backgroundColor: "#ffffff",
                boxShadow: "0px 1px 3px rgba(0.1, 0.1, 0.1, 0.1)",
                marginBottom: "20px",
                width: "100%",
                height: "30px",
                alignItems: "center",
              }}
            >
              <Typography sx={{ marginTop: "-4px" }}>
                <span style={{ color: "#000000" }}>Screenshots</span>
                <span style={{ color: "#2563EB" }}>
                  {" "}
                  - Round-{selectedInterview?.round_no}
                </span>
              </Typography>
            </Box>

            {/* Screenshots Content */}
            <Box
              sx={{ 
                mt: 1, 
                width: "100%", 
                overflow: "auto",
                height: "66vh",
                "&::-webkit-scrollbar": {
                  width: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "4px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "4px",
                  "&:hover": {
                    background: "#555",
                  },
                },
              }}
            >
              {selectedInterview?.screenshots?.map((screenshot, index) => (
                <Card
                  key={`screenshot-${selectedInterview.id}-${index}`}
                  sx={{
                    mb: 2,
                    borderRadius: "8px",
                    boxShadow: "none",
                    border: "1px solid #e0e0e0",
                    fontFamily: "Inter",
                  }}
                  onClick={() => openCarousel(index)}
                >
                  <CardContent>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start", // Changed from center to flex-start
                        mb: 2,
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            color: "#666",
                            fontSize: "14px",
                            fontFamily: "Inter",
                            fontWeight: "500",
                            mb: 1,
                          }}
                        >
                          {formatTimestamp(screenshot.timestamp)}
                        </Typography>
                        <Typography
                          sx={{
                            color: "#666",
                            fontSize: "14px",
                            fontFamily: "Inter",
                            fontWeight: "500",
                          }}
                        >
                          Minutes elapsed:{" "}
                          {screenshot.minutes_elapsed
                            ? parseDuration(screenshot.minutes_elapsed)
                            : "N/A"}
                        </Typography>
                      </Box>
                      <a
                        href={screenshot.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          textDecoration: "none",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          padding: "6px 12px",
                          borderRadius: "4px",
                          backgroundColor: "#2563EB",
                          color: "white",
                          fontSize: "12px",
                          fontFamily: "Inter",
                          fontWeight: "500",
                          transition: "background-color 0.2s",
                          cursor: "pointer",
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.backgroundColor = "#1d4ed8")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.backgroundColor = "#2563EB")
                        }
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z"
                            fill="white"
                          />
                        </svg>
                        View Full Image
                      </a>
                    </Box>
                    <Box
                      sx={{
                        width: "100%",
                        position: "relative",
                        borderRadius: "4px",
                        overflow: "hidden",
                        border: "1px solid #e0e0e0",
                      }}
                    >
                      <img
                        src={screenshot.url}
                        alt={`Interview Screenshot ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "auto",
                          display: "block",
                        }}
                        onClick={() => openCarousel(index)}
                      />
                    </Box>
                  </CardContent>
                </Card>
              ))}
            </Box>
          </Box>
          {/* Screenshot Carousel Modal */}
          {isCarouselOpen && (
            <ScreenshotCarousel
              images={selectedInterview?.screenshots.map((s) => ({
                url: s.url,
                timestamp: formatTimestamp(s.timestamp),
              }))}
              visible={isCarouselOpen}
              onClose={() => setIsCarouselOpen(false)}
              initialIndex={selectedIndex}
              lastIndex={selectedInterview?.screenshots.length - 1}
              onLastImage={() => {
                // When reaching the last image, keep the carousel open but don't reset
                setIsCarouselOpen(true);
              }}
            />
          )}
        </Box>
      </ModalManager>
    );
  };

  // Add state for selected interview ID

  // Modify the click handler for the Flow & Audit button
  const handleFlowAuditClick = (interviewId) => {
    setSelectedInterviewId(interviewId);
    dispatch(
      setOpenModal({
        modalVisible: true,
        modalType: "COMBINED_VIEW",
      })
    );
  };

  // Function to format transcript with colored backgrounds for speakers
  const formatTranscript = (text) => {
    if (!text) return "No transcript available";

    return text.split(/\n/).map((line, lineIndex) => {
      // Check if line starts with Interviewer: or Candidate:
      const isInterviewer = line.trim().startsWith("Interviewer:");
      const isCandidate = line.trim().startsWith("Candidate:");

      // Apply background color based on speaker
      const lineStyle = {
        padding: "2px 4px",
        borderRadius: "3px",
        display: "block",
        marginBottom: "2px",
        backgroundColor: isInterviewer
          ? "#e3f2fd"
          : isCandidate
          ? "#fff8e1"
          : "transparent",
      };

      return (
        <div key={lineIndex} style={lineStyle}>
          {line}
        </div>
      );
    });
  };

  const renderRemarkComponent = () => {
    return (
      <div>
        <div style={{ marginBottom: "16px" }}>
          <Typography
            style={{
              fontSize: "14px",
              fontWeight: 500,
              color: "#374151",
              marginBottom: "6px",
            }}
          >
            Remark Type
          </Typography>
          <MuiSelect
            value={remarkData.type}
            onChange={(e) => handleRemarkTypeChange(e.target.value)}
            fullWidth
            style={{
              height: "40px",
              borderRadius: "6px",
            }}
          >
            <MenuItem value="CALL">CALL</MenuItem>
            <MenuItem value="WHATSAPP">WHATSAPP</MenuItem>
          </MuiSelect>
        </div>

        <div style={{ marginBottom: "16px" }}>
          <Typography
            style={{
              fontSize: "14px",
              fontWeight: 500,
              color: "#374151",
              marginBottom: "6px",
            }}
          >
            Comment
          </Typography>
          <MuiInput
            name="comment"
            value={remarkData.comment}
            onChange={handleRemarkInputChange}
            placeholder="Enter your remark here..."
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: "6px",
              border: "1px solid #D1D5DB",
              fontSize: "14px",
              color: "#374151",
              backgroundColor: "#F9FAFB",
              minHeight: "100px",
              resize: "vertical",
            }}
          />
        </div>
      </div>
    );
  };

  const handleVideoClick = (url) => {
    setVideoUrl(url);
    setIsModalVisible(true);
  };

  const handleFeedbackClick = (data) => {
    setFeedbackModalData(data?.candidate_remark);
    setIsFeedbackModalVisible(!isFeedbackModalVisible);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setVideoUrl("");
  };

  const copyToClipboard = (url) => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        message.success("Recording URL copied to clipboard!");
      })
      .catch((err) => {
        message.error("Failed to copy URL!");
      });
  };
  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  // New function to request candidate feedback via email
  const handleRequestCandidateFeedback = async (interviewId) => {
    setIsRequestingFeedback(true);
    message.loading({ content: "Sending feedback request...", key: "feedbackRequest" });
    try {
      if (!interviewId) {
        throw new Error("Interview ID is undefined");
      }

      const response = await apiCall(
        "post",
        `${apiEndpoints.REQUEST_CANDIDATE_FEEDBACK}/${interviewId}`
      );

      if (response.success) {
        message.success({
          content: "Feedback request sent successfully!",
          key: "feedbackRequest",
        });
        toasty("Candidate feedback request email sent successfully.");
      } else {
        throw new Error(response.message || "Failed to send feedback request");
      }
    } catch (error) {
      console.error("Error sending candidate feedback request:", error);
      message.error({
        content: "Failed to send feedback request",
        key: "feedbackRequest",
      });
      toasty("Failed to send candidate feedback request email.", "error");
    } finally {
      setIsRequestingFeedback(false);
    }
  };

  // New function to send candidate report card
  const handleSendCandidateReportCard = async (interviewId) => {
    setIsSendingReportCard(true);
    message.loading({ content: "Sending report card...", key: "reportCard" });
    try {
      if (!interviewId) {
        throw new Error("Interview ID is undefined");
      }

      const response = await apiCall(
        "post",
        `${apiEndpoints.SEND_REPORT_CARD}/${interviewId}`
      );

      if (response.success) {
        message.success({
          content: "Report card sent successfully!",
          key: "reportCard",
        });
        toasty("Candidate report card email sent successfully.");
      } else {
        throw new Error(response.message || "Failed to send report card");
      }
    } catch (error) {
      console.error("Error sending candidate report card:", error);
      message.error({
        content: "Failed to send report card",
        key: "reportCard",
      });
      toasty("Failed to send candidate report card email.", "error");
    } finally {
      setIsSendingReportCard(false);
    }
  };

  // Add this new function before the return statement
  const handleCheatDetection = async (interviewId) => {
    setIsCheatDetectionLoading(true);
    message.loading({ content: "Running cheat detection...", key: "cheatDetection" });
    try {
      if (!interviewId) {
        throw new Error("Interview ID is undefined");
      }

      const response = await apiCall(
        "put",
        `${apiEndpoints.JOB_INTERVIEW}/cheat-detection/${interviewId}`
      );

      if (response.success) {
        message.success({
          content: "Cheat detection completed successfully!",
          key: "cheatDetection",
        });
        toasty("Cheat detection completed successfully.");
      } else {
        
      }
    } catch (error) {
      console.error("Error running cheat detection:", error);
      message.error({
        content: "Failed to run cheat detection",
        key: "cheatDetection",
      });
      toasty("Failed to run cheat detection.", "error");
    } finally {
      setIsCheatDetectionLoading(false);
    }
  };

  // Add this function before the return statement
  const handleSubmitInterviewIssue = async (interviewId) => {
    if (!selectedIssue) {
      message.error("Please select an issue");
      return;
    }

    if (!interviewId) {
      message.error("Interview ID is missing");
      return;
    }

    setIsSubmittingIssue(true);
    try {
      const response = await apiCall(
        "put",
        `${apiEndpoints.JOB_INTERVIEW}/interview-issue`,
        {
          jobinterview_id: interviewId,
          issue: selectedIssue,
          comments: issueComments || ""
        }
      );

      if (response.success) {
        message.success("Issue reported successfully");
        setInterviewIssueModalOpen(false);
        setSelectedIssue("");
        setIssueComments("");
      } else {
        // throw new Error(response.message || "Failed to report issue");
      }
    } catch (error) {
      console.error("Error reporting interview issue:", error);
      const errorMessage = error.response?.data?.detail?.[0]?.msg || 
                          error.response?.data?.message || 

      message.error(errorMessage);
    } finally {
      setIsSubmittingIssue(false);
      setSelectedIssue("");
      setIssueComments("");
      setInterviewIssueModalOpen(false);
    }
  };

  if (!candidate) {
    return <Typography>Loading candidate details...</Typography>;
  }

  const ApplicantProfle = () => {
    return (
      <TableContainer component={Paper}>
        <Table aria-label="candidate details table">
          <TableBody>
            <TableRow>
              <TableCell colSpan={6}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ width: "100%" }}
                >
                  <Typography align="left" variant="h6"></Typography>
                  <Box sx={{ whiteSpace: "nowrap" }}>
                    {/* Add Reminders button here */}
                    <Button
                      variant="outlined"
                      startIcon={<NotificationsIcon />}
                      onClick={handleRemindersClick}
                      disabled={remindersLoading}
                      style={{
                        marginRight: "10px",
                        width: "150px",
                        height: "28px",
                        position: "relative",

                        bottom: "8px",
                      }}
                    >
                      {remindersLoading ? "Loading..." : "Reminders"}
                    </Button>
                    <img
                      src={EditSvg}
                      alt="Edit Applicant Details"
                      onClick={() =>
                        dispatch(
                          setOpenModal({
                            modalVisible: true,
                            modalType: "EDIT_APPLICANT",
                          })
                        )
                      }
                      style={{
                        cursor: "pointer",
                        height: "28px",
                        width: "150px",
                        marginRight: "10px",
                      }}
                    />
                    <img
                      src={ScheduleInterviewSvg}
                      alt="Schedule Interview"
                      onClick={() =>
                        dispatch(
                          setOpenModal({
                            modalVisible: true,
                            modalType: "SCHEDULE_INTERVIEW",
                          })
                        )
                      }
                      style={{
                        cursor: "pointer",
                        height: "28px",
                        width: "150px",
                      }}
                    />
                  </Box>
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={tableCellStyle}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Name:</strong>
                  <span style={spanStyle}>
                    {candidate.candidate_name || "N/A"}
                  </span>
                </div>
              </TableCell>
              <TableCell style={tableCellStyle}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Email:</strong>
                  <span style={spanStyle}>
                    {candidate.candidate_email || "N/A"}
                  </span>
                </div>
              </TableCell>
              <TableCell style={tableCellStyle}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Phone:</strong>
                  <span style={spanStyle}>
                    {candidate.candidate_phone || "N/A"}
                  </span>
                </div>
              </TableCell>
              <TableCell style={tableCellStyle}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Location:</strong>
                  <span style={spanStyle}>
                    {candidate.current_location || "N/A"}
                  </span>
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={tableCellStyle}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Current CTC:</strong>
                  <span style={spanStyle}>
                    ₹
                    {candidate.current_ctc
                      ? candidate.current_ctc.toLocaleString()
                      : "N/A"}
                  </span>
                </div>
              </TableCell>
              <TableCell style={tableCellStyle}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Expected CTC:</strong>
                  <span style={spanStyle}>
                    ₹
                    {candidate.expected_ctc
                      ? candidate.expected_ctc.toLocaleString()
                      : "N/A"}
                  </span>
                </div>
              </TableCell>
              <TableCell style={tableCellStyle}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Notice Period:</strong>
                  <span style={spanStyle}>
                    {candidate.notice_period || "N/A"}
                  </span>
                </div>
              </TableCell>
              <TableCell style={tableCellStyle}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Experience:</strong>
                  <span style={spanStyle}>{candidate.experience || "N/A"}</span>
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={tableCellStyle}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Current Company:</strong>
                  <span style={spanStyle}>
                    {candidate.current_company || "N/A"}
                  </span>
                </div>
              </TableCell>
              <TableCell style={tableCellStyle}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Notable Companies:</strong>
                  <div
                    style={{
                      ...spanStyle,
                      maxHeight: "66px", // Limit height
                      overflowY: "auto", // Enable vertical scrolling
                      scrollbarWidth: "thin", // For Firefox
                      padding: "2px 8px 2px 0", // Add padding for scrollbar
                      "&::-webkit-scrollbar": {
                        width: "6px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#888",
                        borderRadius: "3px",
                      },
                    }}
                  >
                    {candidate.notable_company
                      ? candidate.notable_company.join(", ")
                      : "N/A"}
                  </div>
                </div>
              </TableCell>
              <TableCell style={tableCellStyle}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Department:</strong>
                  <span style={spanStyle}>
                    {candidate.department_name || "N/A"}
                  </span>
                </div>
              </TableCell>
              <TableCell style={tableCellStyle}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Subdepartment:</strong>
                  <span style={spanStyle}>
                    {candidate.subdepartment_name || "N/A"}
                  </span>
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={tableCellStyle}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Role:</strong>
                  <span style={spanStyle}>{candidate.role_name || "N/A"}</span>
                </div>
              </TableCell>
              <TableCell style={tableCellStyle}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Resume:</strong>
                  <span style={spanStyle}>
                    {candidate.resume_s3_url ? (
                      <a
                        href={candidate.resume_s3_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Link
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </span>
                </div>
              </TableCell>
              <TableCell style={tableCellStyle}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>CV Score:</strong>
                  <span style={spanStyle}>
                    {candidate.ai_score ? `${candidate.ai_score}` : "0.0"}
                  </span>
                </div>
              </TableCell>
              <TableCell style={tableCellStyle}>
                <div style={cellContentStyle}>
                  <strong style={strongStyle}>Individual Score:</strong>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={spanStyle}>{candidate.ai_score || "0.0"}</span>
                    {candidate.individual_scores && (
                      <IconButton
                        size="small"
                        onClick={() => {
                          setSelectedScoreInfo({
                            summary: candidate.ai_summary,
                            candidateName: candidate.candidate_name,
                            individualScores: candidate.individual_scores,
                          });
                          setShowScoreDescription(true);
                        }}
                        style={{ marginLeft: -90 }}
                      >
                        <InfoCircleOutlined />
                      </IconButton>
                    )}
                  </div>
                </div>
              </TableCell>
            </TableRow>
            {candidate.ai_summary ? (
              <TableRow>
                <TableCell style={tableCellStyle} colSpan={6}>
                  <div
                    style={{
                      ...cellContentStyle,
                    }}
                  >
                    <strong style={strongStyle}>CV Summary:</strong>
                    <span style={{ ...spanStyle, height: "100px" }}>
                      {candidate.ai_summary || "N/A"}
                    </span>
                  </div>
                </TableCell>
              </TableRow>
            ) : null}
            <>
              {candidate.education_qualification?.length > 0 && (
                <>
                  <TableRow>
                    <TableCell style={tableCellStyle} colSpan={6}>
                      <Typography
                        variant="h6"
                        style={{
                          fontFamily: "Inter",
                          color: "var(--Gray-700, rgba(78, 78, 86, 1))",
                        }}
                      >
                        Education Qualifications:
                      </Typography>
                    </TableCell>
                  </TableRow>
                  {candidate.education_qualification.map((edu, index) => (
                    <TableRow key={index}>
                      <TableCell style={tableCellStyle} colSpan={2}>
                        <strong style={strongStyle}>Degree:</strong>
                        <span style={spanStyle}>
                          {edu.degree_name || "N/A"}
                        </span>
                      </TableCell>
                      <TableCell style={tableCellStyle} colSpan={2}>
                        {/* <strong>Start Date:</strong> {edu.start_date || "N/A"} */}
                      </TableCell>
                      <TableCell style={tableCellStyle} colSpan={2}>
                        {/* <strong>End Date:</strong> {edu.end_date || "N/A"} */}
                      </TableCell>
                    </TableRow>
                  ))}
                </>
              )}

              {/* Skills Row */}
              {candidate.skills?.length > 0 && (
                <>
                  <TableRow>
                    <TableCell style={tableCellStyle} colSpan={6}>
                      <Typography
                        style={{ fontFamily: "Inter", variant: "h6" }}
                      >
                        Skills
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={tableCellStyle} colSpan={6}>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                        {candidate.skills.map((skill, index) => (
                          <div
                            key={index}
                            style={{
                              border: "1px dashed gray",
                              color: "rgba(0,0,0,0.8)",
                              padding: "6px 20px",
                              borderRadius: "17px",
                              transition:
                                "background-color 0.3s, border-color 0.3s",
                              fontFamily: "Inter",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "rgba(0, 0, 0, 0.1)";
                              e.currentTarget.style.borderColor = "#2c5da7";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.borderColor = "gray";
                            }}
                          >
                            {skill}
                          </div>
                        ))}
                      </Box>
                    </TableCell>
                  </TableRow>
                </>
              )}
            </>
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const InterviewDetails = () => {
    if (roundDetailsData?.length === 0)
      return (
        <div
          style={{
            marginTop: "36vh",
            marginLeft: "30vw",
            fontSize: 16,
            fontFamily: "fantasy",
          }}
        >
          As of now, there is no interview scheduled.
        </div>
      );
    return (
      <TableContainer component={Paper}>
        <Table aria-label="candidate details table">
          <TableBody>
            {roundDetailsData?.map((interview, index) => (
              <React.Fragment key={interview.interview_id}>
                <TableRow>
                  <TableCell style={tableCellStyle} colSpan={6}>
                    <Box
                      sx={interviewDetailsBoxStyle}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRoundToggle(interview.interview_id);
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: "Inter",
                          fontSize: 14,
                          fontWeight: 500,
                          cursor: "pointer",
                        }}
                      >
                        <strong>Round:</strong> {interview?.round_no}{" "}
                        {interview?.round_name}
                        <Typography style={{ fontFamily: "bold" }}>
                          <strong>Status:</strong> {interview.status.status} ⏐{" "}
                          {interview.status?.timestamp
                            ? formatTimestamp(interview.status.timestamp).split(
                                ","
                              )[0]
                            : "N/A"}
                          {interview.status?.timestamp
                            ? formatTimestamp(interview.status.timestamp).split(
                                ","
                              )[1]
                            : "N/A"}{" "}
                        </Typography>
                      </Typography>

                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        <img
                          src={FlowAuditSvg}
                          alt="flow&audit"
                          style={{
                            cursor: "pointer",
                            height: "22px",
                            width: "124px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleFlowAuditClick(interview.interview_id);
                          }}
                        />
                        <div
                          style={{
                            background: "#DBE6FE",
                            borderRadius: 6,
                            padding: "1px 10px",
                          }}
                        >
                          <span
                            style={{
                              cursor: "pointer",
                              fontSize: 12,
                              color: "#2663EB",
                              fontWeight: "600",
                            }}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent collapse toggle
                              // Make sure interview.interview_id is the correct ID expected by your API
                              window.open(
                                `/candidate-report-card/${interview.interview_id}`,
                                "_blank"
                              );
                            }}
                          >
                            Candidate Report Card
                          </span>
                        </div>
                        <img
                          src={ViewReportCardSvg}
                          alt="View Report Card"
                          style={{
                            cursor: "pointer",
                            height: "22px",
                            width: "124px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent collapse toggle
                            // Make sure interview.interview_id is the correct ID expected by your API
                            window.open(
                              `/report-card/${interview.interview_id}`,
                              "_blank"
                            );
                          }}
                        />
                        {!expandedRounds[interview.interview_id] ? (
                          <ExpandLessIcon />
                        ) : (
                          <ExpandMoreIcon />
                        )}
                      </Box>
                    </Box>
                  </TableCell>
                </TableRow>
                {expandedRounds[interview.interview_id] && (
                  <div
                    style={{
                      width: "auto",
                      marginLeft: 20,
                      marginRight: 60,
                      borderRadius: 8,
                    }}
                  >
                    <Card
                      style={{
                        margin: "10px 20px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "14px 12px",
                      }}
                    >
                      <div style={{ display: "flex", gap: 20 }}>
                        <div>
                          <strong style={strongStyle}>Questions Asked:</strong>{" "}
                          {interview?.feedback?.questions_asked != null &&
                          interview.feedback.questions_asked >= 0 ? (
                            <span>{interview.feedback.questions_asked}</span>
                          ) : (
                            <span style={{ color: "#888" }}>0</span>
                          )}
                        </div>
                        <div>
                          <strong style={strongStyle}>Total Questions:</strong>{" "}
                          {interview?.feedback?.total_questions != null ? (
                            <span>{interview.feedback.total_questions}</span>
                          ) : (
                            <span style={{ color: "#888" }}>0</span>
                          )}
                        </div>
                      </div>
                      <Button
                              variant="contained"
                              startIcon={<InfoCircleOutlined />}
                              onClick={() => {
                                setSelectedInterview(interview);
                                setInterviewIssueModalOpen(true);
                              }}
                              sx={{
                                borderRadius: "8px",
                                textTransform: "none",
                                minWidth: "160px",
                                height: "36px",
                                backgroundColor: "#6c757d",
                                "&:hover": {
                                  backgroundColor: "#5a6268",
                                },
                              }}
                            >
                              Interview Issues
                            </Button>
                      <div style={{ display: "flex", gap: "8px" }}>
                        {/* Modified condition to check if candidate feedback is empty in any way */}
                        {(!interview?.candidate_remark || 
                          Object.keys(interview?.candidate_remark || {}).length === 0 ||
                          !interview?.candidate_remark?.Overall) && (
                          <>
                            
                            <Button
                              variant="contained"
                              startIcon={
                                isCheatDetectionLoading ? (
                                  <CircularProgress
                                    size={20}
                                    sx={{ color: "white" }}
                                  />
                                ) : (
                                  <SafetyOutlined />
                                )
                              }
                              onClick={() => handleCheatDetection(interview.interview_id)}
                              disabled={isCheatDetectionLoading}
                              sx={{
                                borderRadius: "8px",
                                textTransform: "none",
                                minWidth: "160px",
                                height: "36px",
                                backgroundColor: "#dc3545",
                                "&:hover": {
                                  backgroundColor: "#c82333",
                                },
                                "&:disabled": {
                                  backgroundColor: "#bdbdbd",
                                },
                              }}
                            >
                              {isCheatDetectionLoading ? "Running..." : "Cheat Detection"}
                            </Button>
                            <Button
                              variant="contained"
                              startIcon={
                                isRequestingFeedback ? (
                                  <CircularProgress
                                    size={20}
                                    sx={{ color: "white" }}
                                  />
                                ) : (
                                  <MailOutlined />
                                )
                              }
                              onClick={() => handleRequestCandidateFeedback(interview.interview_id)}
                              disabled={isRequestingFeedback}
                              sx={{
                                borderRadius: "8px",
                                textTransform: "none",
                                minWidth: "180px",
                                height: "36px",
                                backgroundColor: "#673ab7",
                                "&:hover": {
                                  backgroundColor: "#5e35b1",
                                },
                                "&:disabled": {
                                  backgroundColor: "#bdbdbd",
                                },
                              }}
                            >
                              {isRequestingFeedback ? "Sending..." : "Send candidate feedback"}
                            </Button>
                          </>
                        )}
                        <Button
                          variant="contained"
                          startIcon={
                            isSendingReportCard ? (
                              <CircularProgress
                                size={20}
                                sx={{ color: "white" }}
                              />
                            ) : (
                              <MessageOutlined />
                            )
                          }
                          onClick={() => handleSendCandidateReportCard(interview.interview_id)}
                          disabled={isSendingReportCard}
                          sx={{
                            borderRadius: "8px",
                            textTransform: "none",
                            minWidth: "160px",
                            height: "36px",
                            backgroundColor: "#ff9800",
                            "&:hover": {
                              backgroundColor: "#f57c00",
                            },
                            "&:disabled": {
                              backgroundColor: "#bdbdbd",
                            },
                          }}
                        >
                          {isSendingReportCard ? "Sending..." : "Send Report Card"}
                        </Button>
                        <Button
                          variant="contained"
                          startIcon={
                            isLoading ? (
                              <CircularProgress
                                size={20}
                                sx={{ color: "white" }}
                              />
                            ) : (
                              <RefreshIcon />
                            )
                          }
                          onClick={() =>
                            fetchFeedbackAndTranscript(interview.interview_id)
                          }
                          disabled={isLoading}
                          sx={{
                            borderRadius: "8px",
                            textTransform: "none",
                            minWidth: "160px",
                            height: "36px",
                            backgroundColor: "#2196f3",
                            "&:hover": {
                              backgroundColor: "#1976d2",
                            },
                            "&:disabled": {
                              backgroundColor: "#bdbdbd",
                            },
                          }}
                        >
                          {isLoading ? "Generating..." : "Generate Feedback"}
                        </Button>
                        <Button
                          variant="contained"
                          startIcon={<UpdateIcon />}
                          onClick={() => {
                            // Call the API to update transcript
                            fetchTranscript(interview.interview_id);
                          }}
                          disabled={isTranscriptLoading}
                          sx={{
                            borderRadius: "8px",
                            textTransform: "none",
                            minWidth: "160px",
                            height: "36px",
                            backgroundColor: "#4caf50",
                            "&:hover": {
                              backgroundColor: "#388e3c",
                            },
                            "&:disabled": {
                              backgroundColor: "#bdbdbd",
                            },
                          }}
                        >
                          {isTranscriptLoading
                            ? "Updating..."
                            : "Update Transcript"}
                        </Button>
                      </div>

                      <div style={{ display: "flex", gap: "10px" }}>
                        <Button
                          variant="contained"
                          onClick={() => handleStatusHistoryClick(interview)}
                        >
                          Status History
                        </Button>
                        <Button
                          variant="contained"
                          onClick={() =>
                            handleStatusUpdateClick(interview.job_opening_id, interview.interview_id)
                          }
                        >
                          Update Status
                        </Button>
                      </div>

                      {interview.recording_url?.length > 0 && (
                        <div style={{ display: "flex", gap: "10px" }}>
                          <Button
                            variant="contained"
                            onClick={() =>
                              handleVideoClick(interview.recording_url[0])
                            }
                          >
                            Watch Video
                          </Button>
                          <Button
                            variant="contained"
                            onClick={() =>
                              copyToClipboard(interview.recording_url[0])
                            }
                          >
                            Copy URL
                          </Button>
                        </div>
                      )}
                      {interview?.candidate_remark && (
                        <Button
                          variant="contained"
                          onClick={() => handleFeedbackClick(interview)}
                        >
                          Feedback ⭐️
                        </Button>
                      )}
                    </Card>
                    {interview.transcript && (
                      <TableRow>
                        <TableCell style={tableCellStyle} colSpan={6}>
                          <div style={cellContentStyle}>
                            <strong style={{ fontFamily: "bold" }}>
                              Transcript:
                            </strong>
                            <div
                              style={{
                                padding: 12,
                                lineHeight: 1.8,
                                letterSpacing: 0.8,
                                maxHeight: 220,
                                border: "1px dashed gray",
                                borderRadius: 8,
                                marginTop: 12,
                                color: "rgba(0,0,0,0.8)",
                                overflow: "auto",
                              }}
                            >
                              {formatTranscript(interview.transcript)}
                            </div>
                          </div>
                        </TableCell>
                      </TableRow>
                    )}
                  </div>
                )}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const RemarksData = () => {
    return (
      <Card style={{ margin: 20 }}>
        {candidate.remarks.map((remark, index) => {
          const date = new Date(remark.timestamp);
          const formattedDate = date.toLocaleString(undefined, {
            year: "2-digit",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          });

          return (
            <div
              key={index}
              style={{
                padding: "8px 10px",
                marginBottom: "8px",
                borderBottom:
                  index < candidate.remarks.length - 1
                    ? "1px solid #E5E7EB"
                    : "none",
                backgroundColor: index % 2 === 0 ? "#F9FAFB" : "#FFFFFF",
                borderRadius: "4px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "6px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <span
                    style={{
                      fontWeight: "500",
                      fontSize: "11px",
                      backgroundColor:
                        remark.type === "CALL" ? "#E1EFFE" : "#F0FDF4",
                      color: remark.type === "CALL" ? "#1E40AF" : "#166534",
                      padding: "1px 5px",
                      borderRadius: "3px",
                      display: "inline-block",
                    }}
                  >
                    {remark.type}
                  </span>
                  <span style={{ fontSize: "11px", color: "#6B7280" }}>
                    {formattedDate}
                  </span>
                </div>
              </div>
              <div
                style={{
                  fontSize: "12px",
                  lineHeight: "1.4",
                  color: "#374151",
                  wordBreak: "break-word",
                }}
              >
                {remark.comment}
              </div>
            </div>
          );
        })}
      </Card>
    );
  };

  return (
    <>
      <Tabs activeKey={activeTab} onChange={handleTabChange} type="card">
        <TabPane tab="Applicant Profile" key="1">
          <div style={{ height: "80vh" }}>
            <ApplicantProfle />
          </div>
        </TabPane>
        <TabPane tab="Interview Details" key="2">
          <div style={{ height: "80vh" }}>
            <InterviewDetails />
          </div>
        </TabPane>
        <TabPane tab="Remarks" key="3">
          <Button
            variant="solid"
            startIcon={<MessageOutlined />}
            onClick={handleAddRemark}
            style={{ display: "flex", alignSelf: "flex-end", margin: "0 20px" }}
          >
            Add Remark
          </Button>
          <div style={{ height: "80vh" }}>
            <RemarksData />
          </div>
        </TabPane>
      </Tabs>

      <div className={styles.container}>
        {/* Only render the appropriate modal based on modalType */}
        {modalType === "EDIT_APPLICANT" && renderEditApplicantComponent()}
        {modalType === "SCHEDULE_INTERVIEW" && renderScheduleComponent()}
        {modalType === "COMBINED_VIEW" && renderCombinedFlowAndAuditComponent()}

        {/* Status History Dialog */}
        <Dialog
          open={statusHistoryOpen}
          onClose={() => setStatusHistoryOpen(false)}
        >
          <DialogTitle>Status History</DialogTitle>
          <DialogContent>
            <List>
              {selectedInterview?.status_history.map((status, index) => (
                <ListItem key={index}>
                  <ListItemText
                    primary={`Status: ${status.status}`}
                    secondary={
                      <>
                        <Typography
                          component="span"
                          variant="body2"
                          color="textPrimary"
                        >
                          Timestamp: {formatTimestamp(status.timestamp)}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant="body2"
                          color="textPrimary"
                        >
                          Remarks: {status.remarks || "No remarks"}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant="body2"
                          color="textPrimary"
                        >
                          Updated by: {status.user_name} (ID: {status.user_id})
                        </Typography>
                      </>
                    }
                  />
                </ListItem>
              ))}
            </List>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setStatusHistoryOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>

        {/* Status Update Dialog */}
        <Dialog
          open={statusUpdateOpen}
          onClose={() => setStatusUpdateOpen(false)}
        >
          <DialogTitle>Update Status</DialogTitle>
          <DialogContent>
            <MuiSelect
              value={newStatus}
              onChange={(e) => setNewStatus(e.target.value)}
              fullWidth
              margin="normal"
            >
              <MenuItem value="COMPLETED">Completed</MenuItem>
              <MenuItem value="CANCELED">Canceled</MenuItem>
              <MenuItem value="VERIFIED">Verified</MenuItem>
              <MenuItem value="CHEATED">Cheated</MenuItem>
              <MenuItem value="SCHEDULED">SCHEDULED</MenuItem>
              <MenuItem value="TECH_ISSUE">Tech Issue</MenuItem>
              <MenuItem value="PASSED">Passed</MenuItem>
              <MenuItem value="TEST_INTERVIEW">Test Interview</MenuItem>
              <MenuItem value="REJECTED">Rejected</MenuItem>
              <MenuItem value="NOT_INTERESTED">Not Interested</MenuItem>
              <MenuItem value="COMPANY_REJECTED">Company Rejected</MenuItem>

           
             

            </MuiSelect>
            <TextField
              label="Remarks"
              value={statusRemarks}
              onChange={(e) => setStatusRemarks(e.target.value)}
              fullWidth
              margin="normal"
              multiline
              rows={3}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setStatusUpdateOpen(false)}>Cancel</Button>
            <Button onClick={handleStatusUpdate} color="primary">
              Update
            </Button>
          </DialogActions>
        </Dialog>

        {/* Reminders Dialog */}
        <Modal
          title={
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <BellOutlined style={{ color: "#2563EB", fontSize: "20px" }} />
              <span>Email Reminders</span>
            </div>
          }
          open={remindersOpen}
          onCancel={() => setRemindersOpen(false)}
          footer={[
            <Button
              key="close"
              onClick={() => setRemindersOpen(false)}
              style={{ borderRadius: "6px" }}
            >
              Close
            </Button>,
          ]}
          width={800}
          bodyStyle={{ padding: "20px", maxHeight: "70vh", overflowY: "auto" }}
        >
          {remindersLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "40px",
              }}
            >
              <Spin size="large" tip="Loading reminders..." />
            </div>
          ) : remindersData ? (
            <>
              <Row gutter={16} style={{ marginBottom: "20px" }}>
                <Col span={12}>
                  <Card
                    bordered={false}
                    style={{ backgroundColor: "#f0f5ff", borderRadius: "8px" }}
                  >
                    <Statistic
                      title="Sent Reminders"
                      value={remindersData.totalSentCount}
                      valueStyle={{ color: "#2563EB" }}
                      prefix={<CheckCircleOutlined />}
                    />
                  </Card>
                </Col>
                <Col span={12}>
                  <Card
                    bordered={false}
                    style={{ backgroundColor: "#fff7e6", borderRadius: "8px" }}
                  >
                    <Statistic
                      title="Pending Reminders"
                      value={remindersData.totalPendingCount}
                      valueStyle={{ color: "#fa8c16" }}
                      prefix={<ClockCircleOutlined />}
                    />
                  </Card>
                </Col>
              </Row>

              <Tabs defaultActiveKey="1">
                <Tabs.TabPane
                  tab={
                    <span>
                      <Badge
                        count={remindersData.totalSentCount}
                        style={{ backgroundColor: "#2563EB" }}
                      >
                        <span style={{ padding: "0 8px" }}>Sent Reminders</span>
                      </Badge>
                    </span>
                  }
                  key="1"
                >
                  {remindersData.rounds &&
                  Object.keys(remindersData.rounds).length > 0 ? (
                    <div>
                      {Object.keys(remindersData.rounds).map((roundKey) => {
                        const roundData = remindersData.rounds[roundKey];
                        if (
                          !roundData.sent_reminders ||
                          roundData.sent_reminders.length === 0
                        ) {
                          return null;
                        }

                        return (
                          <div
                            key={`sent-${roundKey}`}
                            style={{ marginBottom: "20px" }}
                          >
                            <Divider orientation="left">
                              <Tag
                                color="blue"
                                style={{ fontSize: "14px", padding: "4px 8px" }}
                              >
                                Round {roundKey}
                              </Tag>
                            </Divider>

                            <AntTable
                              dataSource={roundData.sent_reminders.map(
                                (reminder, index) => ({
                                  key: reminder.reminder_id,
                                  num: index + 1,
                                  id: reminder.reminder_id,
                                  time: reminder.sent_time,
                                  formattedTime: formatReminderTime(
                                    reminder.sent_time
                                  ),
                                })
                              )}
                              columns={[
                                {
                                  title: "#",
                                  dataIndex: "num",
                                  key: "num",
                                  width: "5%",
                                },
                                {
                                  title: "Reminder ID",
                                  dataIndex: "id",
                                  key: "id",
                                  width: "40%",
                                  render: (text) => (
                                    <span
                                      style={{
                                        fontFamily: "monospace",
                                        fontSize: "13px",
                                      }}
                                    >
                                      {text}
                                    </span>
                                  ),
                                },
                                {
                                  title: "Sent Time",
                                  dataIndex: "formattedTime",
                                  key: "formattedTime",
                                  width: "55%",
                                  render: (text) => (
                                    <Tag color="blue">{text}</Tag>
                                  ),
                                },
                              ]}
                              pagination={{ pageSize: 5 }}
                              size="small"
                              bordered
                            />
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <Empty
                      description="No sent reminders"
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                    />
                  )}
                </Tabs.TabPane>

                <Tabs.TabPane
                  tab={
                    <span>
                      <Badge
                        count={remindersData.totalPendingCount}
                        style={{ backgroundColor: "#fa8c16" }}
                      >
                        <span style={{ padding: "0 8px" }}>
                          Pending Reminders
                        </span>
                      </Badge>
                    </span>
                  }
                  key="2"
                >
                  {remindersData.rounds &&
                  Object.keys(remindersData.rounds).length > 0 ? (
                    <div>
                      {Object.keys(remindersData.rounds).map((roundKey) => {
                        const roundData = remindersData.rounds[roundKey];
                        if (
                          !roundData.pending_reminders ||
                          roundData.pending_reminders.length === 0
                        ) {
                          return null;
                        }

                        return (
                          <div
                            key={`pending-${roundKey}`}
                            style={{ marginBottom: "20px" }}
                          >
                            <Divider orientation="left">
                              <Tag
                                color="orange"
                                style={{ fontSize: "14px", padding: "4px 8px" }}
                              >
                                Round {roundKey}
                              </Tag>
                            </Divider>

                            <AntTable
                              dataSource={roundData.pending_reminders.map(
                                (reminder, index) => ({
                                  key: reminder.reminder_id,
                                  num: index + 1,
                                  id: reminder.reminder_id,
                                  time: reminder.scheduled_time,
                                  formattedTime: formatReminderTime(
                                    reminder.scheduled_time
                                  ),
                                })
                              )}
                              columns={[
                                {
                                  title: "#",
                                  dataIndex: "num",
                                  key: "num",
                                  width: "5%",
                                },
                                {
                                  title: "Reminder ID",
                                  dataIndex: "id",
                                  key: "id",
                                  width: "40%",
                                  render: (text) => (
                                    <span
                                      style={{
                                        fontFamily: "monospace",
                                        fontSize: "13px",
                                      }}
                                    >
                                      {text}
                                    </span>
                                  ),
                                },
                                {
                                  title: "Scheduled Time",
                                  dataIndex: "formattedTime",
                                  key: "formattedTime",
                                  width: "55%",
                                  render: (text) => (
                                    <Tag color="orange">{text}</Tag>
                                  ),
                                },
                              ]}
                              pagination={{ pageSize: 10 }}
                              size="small"
                              bordered
                            />
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <Empty
                      description="No pending reminders"
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                    />
                  )}
                </Tabs.TabPane>
              </Tabs>

              <Divider style={{ margin: "16px 0" }} />

              <div
                style={{ fontSize: "12px", color: "#888", textAlign: "center" }}
              >
                {Object.keys(remindersData.rounds).map((roundKey) => (
                  <div
                    key={`job-id-${roundKey}`}
                    style={{ marginBottom: "4px" }}
                  >
                    Round {roundKey} - Job Interview ID:{" "}
                    {remindersData.rounds[roundKey].job_interview_id}
                  </div>
                ))}
              </div>
            </>
          ) : (
            <Empty
              description="No reminder data available"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          )}
        </Modal>

        <Modal
          title={`Score Details - ${
            selectedScoreInfo?.candidateName || "Candidate"
          }`}
          open={showScoreDescription}
          onCancel={() => setShowScoreDescription(false)}
          footer={[
            <Button key="close" onClick={() => setShowScoreDescription(false)}>
              Close
            </Button>,
          ]}
          width={600}
        >
          <div
            style={{
              fontFamily: "Inter",
              fontSize: "14px",
              lineHeight: "1.6",
            }}
          >
            <h3 style={{ marginTop: 0 }}>Individual Score Breakdown</h3>

            {selectedScoreInfo?.individualScores && (
              <div style={{ marginBottom: "20px" }}>
                {Object.entries(selectedScoreInfo.individualScores)
                  .filter(
                    ([category]) => category !== "weighted_criterias_score"
                  )
                  .map(([category, data]) => (
                    <div key={category} style={{ marginBottom: "16px" }}>
                      <h4
                        style={{
                          margin: "10px 0 5px 0",
                          fontSize: "15px",
                          fontWeight: "500",
                        }}
                      >
                        {category
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (l) => l.toUpperCase())}{" "}
                        - {data.score}/10
                      </h4>
                      <p style={{ margin: "0 0 8px 0" }}>{data.explanation}</p>
                      <div
                        style={{
                          height: "1px",
                          background: "#f0f0f0",
                          margin: "10px 0",
                        }}
                      ></div>
                    </div>
                  ))}
              </div>
            )}
          </div>
        </Modal>

        {/* Feedback Status Modal */}
        <Modal
          title="Feedback Generation Status"
          open={feedbackStatusOpen}
          onCancel={() => setFeedbackStatusOpen(false)}
          footer={[
            <Button key="close" onClick={() => setFeedbackStatusOpen(false)}>
              Close
            </Button>,
          ]}
        >
          {feedbackStatus ? (
            <div>
              <Row gutter={16}>
                <Col span={24}>
                  <Statistic
                    title="Status"
                    value={feedbackStatus.status}
                    valueStyle={{
                      color:
                        feedbackStatus.status === "PROCESSING"
                          ? "#1890ff"
                          : feedbackStatus.status === "COMPLETED"
                          ? "#52c41a"
                          : feedbackStatus.status === "ERROR"
                          ? "#f5222d"
                          : "#000000",
                    }}
                    prefix={
                      feedbackStatus.status === "PROCESSING" ? (
                        <ClockCircleOutlined />
                      ) : feedbackStatus.status === "COMPLETED" ? (
                        <CheckCircleOutlined />
                      ) : feedbackStatus.status === "ERROR" ? (
                        <ExclamationCircleOutlined />
                      ) : (
                        <InfoCircleOutlined />
                      )
                    }
                  />
                </Col>
              </Row>
              <Divider />
              <Row gutter={16}>
                <Col span={12}>
                  <Statistic
                    title="Started At"
                    value={
                      feedbackStatus.started_at
                        ? new Date(feedbackStatus.started_at).toLocaleString()
                        : "N/A"
                    }
                  />
                </Col>
                <Col span={12}>
                  <Statistic
                    title="Completed At"
                    value={
                      feedbackStatus.completed_at
                        ? new Date(feedbackStatus.completed_at).toLocaleString()
                        : "N/A"
                    }
                  />
                </Col>
              </Row>
              {feedbackStatus.error && (
                <>
                  <Divider />
                  <Row>
                    <Col span={24}>
                      <Typography.Title level={5}>Error</Typography.Title>
                      <Typography.Text type="danger">
                        {feedbackStatus.error}
                      </Typography.Text>
                    </Col>
                  </Row>
                </>
              )}
            </div>
          ) : (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <Spin tip="Loading status..." />
            </div>
          )}
        </Modal>

        {/* Correction Status Modal */}
        <Modal
          title="Transcript Correction Status"
          open={correctionStatusOpen}
          onCancel={() => setCorrectionStatusOpen(false)}
          footer={[
            <Button key="close" onClick={() => setCorrectionStatusOpen(false)}>
              Close
            </Button>,
          ]}
        >
          {correctionStatus ? (
            <div>
              <Row gutter={16}>
                <Col span={24}>
                  <Statistic
                    title="Status"
                    value={correctionStatus.status}
                    valueStyle={{
                      color:
                        correctionStatus.status === "PROCESSING"
                          ? "#1890ff"
                          : correctionStatus.status === "COMPLETED"
                          ? "#52c41a"
                          : correctionStatus.status === "ERROR"
                          ? "#f5222d"
                          : "#000000",
                    }}
                    prefix={
                      correctionStatus.status === "PROCESSING" ? (
                        <ClockCircleOutlined />
                      ) : correctionStatus.status === "COMPLETED" ? (
                        <CheckCircleOutlined />
                      ) : correctionStatus.status === "ERROR" ? (
                        <ExclamationCircleOutlined />
                      ) : (
                        <InfoCircleOutlined />
                      )
                    }
                  />
                </Col>
              </Row>
              <Divider />
              <Row gutter={16}>
                <Col span={12}>
                  <Statistic
                    title="Started At"
                    value={
                      correctionStatus.started_at
                        ? new Date(correctionStatus.started_at).toLocaleString()
                        : "N/A"
                    }
                  />
                </Col>
                <Col span={12}>
                  <Statistic
                    title="Completed At"
                    value={
                      correctionStatus.completed_at
                        ? new Date(
                            correctionStatus.completed_at
                          ).toLocaleString()
                        : "N/A"
                    }
                  />
                </Col>
              </Row>
              {correctionStatus.error && (
                <>
                  <Divider />
                  <Row>
                    <Col span={24}>
                      <Typography.Title level={5}>Error</Typography.Title>
                      <Typography.Text type="danger">
                        {correctionStatus.error}
                      </Typography.Text>
                    </Col>
                  </Row>
                </>
              )}
            </div>
          ) : (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <Spin tip="Loading status..." />
            </div>
          )}
        </Modal>

        <Modal
          title="Add Remark"
          open={showRemarkModal}
          onCancel={() => setShowRemarkModal(false)}
          footer={[
            <Button key="close" onClick={() => setShowRemarkModal(false)}>
              Cancel
            </Button>,
            <Button key="submit" type="primary" onClick={handleSubmitRemark}>
              Submit
            </Button>,
          ]}
        >
          {renderRemarkComponent()}
        </Modal>

        <Modal
          title="Video Recording"
          visible={isModalVisible}
          onCancel={handleModalClose}
          footer={null}
        >
          <video width="100%" controls>
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </Modal>

        <Modal
          title="Candidate Feedback"
          visible={isFeedbackModalVisible}
          onCancel={handleFeedbackClick}
          footer={null}
        >
          <div
            style={{
              padding: "20px",
              backgroundColor: "#f9f9f9",
              borderRadius: "8px",
            }}
          >
            {feedbackModalData ? (
              <div>
                <h3 style={{ marginBottom: "20px" }}>Feedback Summary</h3>

                {[
                  {
                    label: "Question Level",
                    score: feedbackModalData.Question_Level,
                  },
                  { label: "Sarah Flow", score: feedbackModalData.Sarah_flow },
                  {
                    label: "Technical Stability",
                    score: feedbackModalData.Technical_Stability,
                  },
                  { label: "Overall Score", score: feedbackModalData.Overall },
                ].map((item, index) => (
                  <div
                    key={index}
                    style={{
                      marginBottom: "15px",
                      padding: "10px",
                      border: "1px solid #ddd",
                      borderRadius: "5px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <strong style={{ width: "150px" }}>{item.label}:</strong>
                      <div>
                        {Array(item.score)
                          .fill(0)
                          .map((_, starIndex) => (
                            <span
                              key={starIndex}
                              style={{
                                color: "gold",
                                fontSize: "24px",
                              }}
                            >
                              ★
                            </span>
                          ))}
                        {Array(5 - item.score)
                          .fill(0)
                          .map((_, starIndex) => (
                            <span
                              key={starIndex + 5}
                              style={{
                                color: "lightgray",
                                fontSize: "24px",
                              }}
                            >
                              ★
                            </span>
                          ))}
                      </div>
                    </div>
                  </div>
                ))}
              {feedbackModalData?.Any_other_feedback && <>
          
                  <p>
                    <strong>Remarks:</strong> {feedbackModalData?.Any_other_feedback}
                  </p></> }
                  </div>
                  
            ) : (
              <p>Loading feedback...</p>
            )}
          </div>
        </Modal>

        <Modal
          title="Report Interview Issue"
          open={interviewIssueModalOpen}
          onCancel={() => setInterviewIssueModalOpen(false)}
          footer={[
            <Button key="cancel" onClick={() => setInterviewIssueModalOpen(false)}>
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={() => {
                if (!selectedInterview?.interview_id) {
                  message.error("Interview ID is missing");
                  return;
                }
                handleSubmitInterviewIssue(selectedInterview.interview_id);
              }}
              loading={isSubmittingIssue}
            >
              Submit
            </Button>,
          ]}
        >
          <div style={{ padding: "20px" }}>
            <div style={{ marginBottom: "20px" }}>
              <Typography style={{ marginBottom: "8px" }}>Select Issue Type</Typography>
              <Select
                style={{ width: "100%" , boxShadow: "0 2px 8px rgba(0, 0.15, 0.15, 0.15)", borderRadius: "6px", height: "50px" }}
                value={selectedIssue}
                onChange={(value) => setSelectedIssue(value)}
                placeholder="Select an issue"
              >
                <Select.Option value="TECH_ISSUE">Tech Issue</Select.Option>
                <Select.Option value="CANDIDATE_NETWORK_ISSUE">Candidate Network Issue</Select.Option>
                <Select.Option value="CANDIDATE_SYSTEM_ISSUE">Candidate System Issue</Select.Option>
                <Select.Option value="MICROPHONE_ISSUE">Microphone Issue</Select.Option>
                <Select.Option value="FACE_NOT_DETECTED">Face Not Detected</Select.Option>
                <Select.Option value="INTERNET_DISCONNECT">Internet Disconnect</Select.Option>
                <Select.Option value="SYSTEM_DISCHARGE">System Discharge</Select.Option>
                <Select.Option value="SIDE_CAMERA_DISCONNECT">Side Camera Disconnect</Select.Option>
                <Select.Option value="WEBSCOKET_DISCONNECT">Websocket Disconnect</Select.Option>
                <Select.Option value="OTHERS">Others</Select.Option>
              </Select>
              
            </div>
            <div>
              <Typography style={{ marginBottom: "8px" }}>Comments</Typography>
              <AntInput.TextArea
                value={issueComments}
                onChange={(e) => setIssueComments(e.target.value)}
                placeholder="Enter any additional comments about the issue"
                rows={4}
              />
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default CandidateDetailsTable;
